import { useState, useCallback } from 'react';

export function usePanelState() {
  // Left panel state
  const [isLeftPanelCollapsed, setIsLeftPanelCollapsed] = useState(false);
  
  // Right panel state  
  const [isRightPanelCollapsed, setIsRightPanelCollapsed] = useState(true);
  
  // Bottom panel state
  const [bottomPanelOpen, setBottomPanelOpen] = useState(true);
  
  // Calculate ~50% of available viewport (accounting for header and toolbar)
  const getInitialPanelHeight = () => {
    const viewportHeight = window.innerHeight;
    const headerAndToolbarHeight = 100; // Approximate header + toolbar height
    const availableHeight = viewportHeight - headerAndToolbarHeight;
    return Math.round(availableHeight * 0.5); // 50% of available space
  };
  
  const [bottomPanelHeight, setBottomPanelHeight] = useState(getInitialPanelHeight);
  
  // Handle opening the right panel when entry is selected
  const openRightPanel = useCallback(() => {
    setIsRightPanelCollapsed(false);
  }, []);
  
  // Handle opening the bottom panel when zipfile is selected
  const openBottomPanel = useCallback(() => {
    setBottomPanelOpen(true);
  }, []);
  
  return {
    // Left panel
    isLeftPanelCollapsed,
    setIsLeftPanelCollapsed,
    
    // Right panel
    isRightPanelCollapsed,
    setIsRightPanelCollapsed,
    openRightPanel,
    
    // Bottom panel
    bottomPanelOpen,
    setBottomPanelOpen,
    bottomPanelHeight,
    setBottomPanelHeight,
    openBottomPanel,
  };
}